import { call, getContext, put, takeEvery } from "redux-saga/effects";
import { CONTEXT } from "@const/redux";
import { updateEmailFailure, updateEmailSuccess } from "./actions";
import { updateEmailActionTypes } from "./actionTypes";
import {
  resendVerificationLinkFailure,
  resendVerificationLinkSuccess,
} from "../verification/actions";

const updateEmailAsync = ({ UsersService, values }) => {
  if (!UsersService) {
    console.log("Required services does not exist");

    return null;
  }

  return UsersService.updateEmail(values);
};

function* updateEmail({ payload }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(updateEmailAsync, {
      UsersService,
      values: payload,
    });

    yield put(updateEmailSuccess(data));
    yield put(resendVerificationLinkSuccess());
  } catch ({ error }) {
    yield put(updateEmailFailure(error));
    yield put(resendVerificationLinkFailure(error));
  }
}

export function* watchUpdateEmail() {
  yield takeEvery(updateEmailActionTypes.request, updateEmail);
}
